import React, { useEffect, useState } from 'react';
import pt from 'prop-types';
import InfiniteGrid from '../infiniteGrid';
import { getFiltersFromQueryParams } from '../../../../../helpers/filters';

import { getAPIRoot } from '../../../../../helpers/fetch';
import { API_ROUTES } from '../../../../../utils/constants';

const DEFAULT_FILTERS = {
  types: [],
  range: 4,
  countries: [],
  fieldsOfWork: [],
  businessSectors: [],
  find: '',
};

const QUERY_PARAM_MAPPING = {
  profileTypeId: 'types',
  fieldOfWorkId: 'fieldsOfWork',
  countryId: 'countries',
  yearId: 'range',
  regionId: 'countries',
};

const InfiniteCompanies = ({ setTotal, filtersAsQueryString, limit }) => {
  const [results, setResults] = useState([]);
  const [regionCountryMapping, setRegionCountryMapping] = useState({});
  const [loading, setLoading] = useState(true);

  const CUSTOM_RESOLVERS = {
    regionId: (id) => regionCountryMapping[id],
  };

  const filters = getFiltersFromQueryParams(
    DEFAULT_FILTERS,
    filtersAsQueryString,
    QUERY_PARAM_MAPPING,
    CUSTOM_RESOLVERS
  );

  const fetchFilters = async () => {
    let apiRoot = await getAPIRoot();

    await fetch(`${apiRoot}${API_ROUTES.JURORS_FILTERS}`)
      .then((res) => res.json())
      .then((res) => {
        const mapping = {};
        res.countries.forEach((country) => {
          if (mapping.hasOwnProperty(country.region)) {
            mapping[country.region] = mapping[country.region].concat(
              country.id
            );
          } else {
            mapping[country.region] = [country.id];
          }
        });
        setRegionCountryMapping(mapping);
      });
  };

  const fetchResults = async () => {
    let apiRoot = await getAPIRoot();

    await fetch(`${apiRoot}${API_ROUTES.UNPAGINATED_COMPANIES}/${limit}`, {
      method: 'POST',
      redirect: 'follow',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    })
      .then((res) => res.json())
      .then((res) => {
        const data = res.items
          .sort((a, b) => a.surname?.localeCompare(b?.surname))
          .map((item) => {
            return {
              image: { url: item.image, description: item.companyName },
              title: item.companyName,
              info: item.firstClient,
              imageBadge: item.logo,
              link: { linkToPage: item.slug },
            };
          });
        setLoading(false);
        setResults(data);
        setTotal(res.count);
      });
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    if (Object.keys(regionCountryMapping).length) {
      fetchResults();
    }
  }, [regionCountryMapping]);

  return <InfiniteGrid items={results} loading={loading} />;
};

InfiniteCompanies.propTypes = {
  setTotal: pt.func,
  filtersAsQueryString: pt.string,
  limit: pt.number,
};

InfiniteCompanies.defaultProps = {
  setTotal: () => {},
  filtersAsQueryString: '',
  limit: 150,
};

export default InfiniteCompanies;
